// extracted by mini-css-extract-plugin
export default {"threadContainer":"questionThread_threadContainer__r+nj8","threadRepliesContainer":"questionThread_threadRepliesContainer__kF00P"};